import React from "react";
import comingsoon from "../../assets/images/comingSoon.png";
const FreeDrop = () => {
  return (
    <div className="text-center p-4">
      <h1>Free Drops Coming Soon...</h1>
      <img src={comingsoon} alt="" width={"200px"} />
    </div>
  );
};

export default FreeDrop;
